<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">答題記錄</h1>
      </div>
      <div class="header-right">
        <el-tag effect="plain">答題學生：{{ usertotal }}人</el-tag>
      </div>
    </div>

    <div class="layout">
      <!-- 统一风格搜索区 -->
      <div class="search-card">
        <div class="search-row">
          <div v-if="userInfoRoleRoleId == siteAdminRoleId">
            <el-select
                size="small"
                v-model="listQuery.branchSchoolId"
                placeholder="請選擇分校"
                filterable
                ref="branchSchoolSelect"
                :filter-method="filterBranchSchool"
                clearable
                style="width: 100%;"
            >
              <el-option
                  v-for="(item) in filteredBranchSchools"
                  :key="item.id"
                  :label="`${item.abbreviation || ''}${item.nameZh || ''}`"
                  :value="item.id"
                  :title="`${item.abbreviation || ''}${item.nameZh || ''}`"
              ></el-option>
            </el-select>
          </div>
          <el-select v-model="listQuery.gradeId" clearable placeholder="全部年級" size="small">
            <el-option
                v-for="(item, index) in $store.getters.grades"
                :key="index"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
          <el-input
              v-model="listQuery.userNoLike"
              placeholder="搜尋學生帳號"
              prefix-icon="el-icon-user"
              size="small"
              clearable
          ></el-input>
          <el-input
              v-model="listQuery.studentCodeLike"
              placeholder="搜尋學生編號"
              prefix-icon="el-icon-user"
              size="small"
              clearable
          ></el-input>
          <el-input
              v-model="listQuery.userNameLike"
              placeholder="搜尋學生姓名"
              prefix-icon="el-icon-user"
              size="small"
              clearable
          ></el-input>
          <el-select v-model="listQuery.objectType" clearable placeholder="全部模式" size="small">
            <el-option label="圖書館/冒險" value="0">圖書館/冒險</el-option>
            <el-option label="小測" value="1">小測</el-option>
            <el-option label="評估" value="2">評估</el-option>
            <el-option label="作業" value="3">作業</el-option>
          </el-select>
          <el-date-picker
              style="width: 226px;"
              size="small"
              clearable
              v-model="listQuery.createdAt"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="做題開始日期"
              end-placeholder="做題截止日期"
              :picker-options="pickerOptions"
          ></el-date-picker>
          <div class="search-buttons">
            <el-button size="small" type="warning" @click.native="onSearch" icon="el-icon-search">搜尋</el-button>
            <el-button size="small" @click="onReset" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
      </div>

      <!-- 统一风格 PC表格 + 手机卡片 -->
      <div class="table-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              @sort-change="handleSortChange"
              :data="tableData"
              style="width: 100%;"
              v-loading="tableLoading"
              element-loading-background="rgba(255, 255, 255, 0.8)"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 ? '暫無答題記錄' : ''"
          >
            <el-table-column label="#" type="index" width="50" align="center"> </el-table-column>
            <el-table-column label="年級" min-width="60" align="center">
              <template slot-scope="{ row }">
                <span v-if="row.gradeId==1">小一</span>
                <span v-if="row.gradeId==2">小二</span>
                <span v-if="row.gradeId==3">小三</span>
                <span v-if="row.gradeId==4">小四</span>
                <span v-if="row.gradeId==5">小五</span>
                <span v-if="row.gradeId==6">小六</span>
              </template>
            </el-table-column>
            <el-table-column label="模式" min-width="80" align="center">
              <template slot-scope="{ row }">
                <span v-if="row.objectType==0">圖書館/冒險</span>
                <span v-if="row.objectType==1">小測</span>
                <span v-if="row.objectType==2">評估</span>
                <span v-if="row.objectType==3">作業</span>
              </template>
            </el-table-column>
            <el-table-column prop="topicName" label="課題名稱" min-width="120" align="center"></el-table-column>
            <el-table-column prop="objectName" label="練習名稱" min-width="120" align="center"></el-table-column>
            <el-table-column prop="userNo" label="學生帳號" min-width="80" align="center"></el-table-column>
            <el-table-column prop="studentCode" label="學生編號" min-width="80" align="center"></el-table-column>
            <el-table-column prop="userName" label="學生姓名" min-width="80" align="center"></el-table-column>
            <el-table-column
                prop="endTime"
                label="結束時間"
                width="160"
                align="center"
                :formatter="myFormatter"
            ></el-table-column>
            <el-table-column label="時長" min-width="80" align="center">
              <template slot-scope="scope">
                約{{scope.row.answeringMinutes || 0}}分鐘
              </template>
            </el-table-column>
            <el-table-column label="得分/總分" min-width="80" align="center">
              <template slot-scope="scope">
                {{scope.row.correctQuantity || 0}}/{{scope.row.score || 0}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button
                    type="text" size="small"
                    @click="navigateToResult(scope.row)"
                    icon="el-icon-view"
                >
                  答題記錄
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片列表（<768px显示） -->
        <div class="mobile-cards">
          <div class="user-card" v-for="(item) in tableData" :key="item.id">
            <div class="card-header">
              <div class="user-name">{{ item.topicName }}</div>
              <el-tag size="mini" type="info">
                {{ getModeText(item.objectType) }}
              </el-tag>
            </div>
            <div class="card-body">
              <div class="info-item">
                <span class="info-label">年級：</span>
                <span class="info-value">{{ getGradeText(item.gradeId) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">練習名稱：</span>
                <span class="info-value">{{ item.objectName || '未填寫' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">學生帳號：</span>
                <span class="info-value">{{ item.userNo || '未填寫' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">學生編號：</span>
                <span class="info-value">{{ item.studentCode || '未填寫' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">學生姓名：</span>
                <span class="info-value">{{ item.userName || '未填寫' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">開始時間：</span>
                <span class="info-value">{{ myFormatter(item, 'startTime', item.startTime) }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">時長：</span>
                <span class="info-value">約{{ item.answeringMinutes || 0 }}分鐘</span>
              </div>
              <div class="info-item">
                <span class="info-label">得分/總分：</span>
                <span class="info-value">{{ item.correctQuantity || 0 }}/{{ item.score || 0 }}</span>
              </div>
            </div>
            <div class="card-footer">
              <el-button size="mini" type="warning" @click="navigateToResult(item)" icon="el-icon-view">
                查看答題記錄
              </el-button>
            </div>
          </div>
          <div class="empty-tip" v-if="tableData.length === 0 && !tableLoading">
            暫無答題記錄
          </div>
        </div>
      </div>
    </div>

    <!-- 统一风格分页 -->
    <div class="pagination-wrap">
      <Pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery._page"
          :limit.sync="listQuery._limit"
          @pagination="getAnswerResults"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { downloadFile } from "@/utils/is-rules";
import { getStudentReport } from "@/api/report";
import { getAnswerResults,countAdminAnswerResults } from "@/api/answerResult";
import { formatDateTime } from "@/filters";

export default {
  components: { Pagination },
  filters: {
    studentCodeStatus(v) {
      return v === 0 ? "封鎖" : "生效";
    },
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一個月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三個月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 12);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      total: 0,
      usertotal: 0,
      userId: null,
      listQuery: {
        userNoLike: null,
        userNameLike: null,
        parentEmailLike: null,
        studentCodeLike: null,
        gender: null,
        gradeId: null,
        objectType: null,
        createdAt: '',
        branchSchoolId: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      ruleForm: {
        students: [
          {
            id: 0,
            userNo: "",
            name: "",
            gender: null,
            school: "",
            password: "",
            gradeId: null,
          },
        ],
      },
      centerDialogVisible: false,
      dialogSlotVisible: false,
      filteredBranchSchools: [],
      tableData: [],
      tableLoading: false,
      avatars: [],
      // 全局变量映射（根据实际业务调整）
      userInfoRoleRoleId: this.$store.getters.userInfo?.roleId || '',
      siteAdminRoleId: 1 // 假设站点管理员角色ID为1，根据实际值调整
    };
  },
  created() {
    this.getAnswerResults();
    this.countAdminAnswerResults();
    this.filteredBranchSchools = this.$store.getters.branchSchools || [];
  },
  methods: {
    filterBranchSchool(val) {
      // 1. 兜底获取分校列表，避免 null/undefined
      const branchSchools = this.$store.getters.branchSchools || [];

      if (!val) {
        // 输入为空时显示全部
        this.filteredBranchSchools = branchSchools;
      } else {
        // 2. 统一转小写+去除首尾空格，保证匹配一致性
        const searchText = val.toLowerCase().trim();

        // 3. 同时匹配 abbreviation 和 nameZh（都做空值兜底）
        this.filteredBranchSchools = branchSchools.filter(item => {
          // 空值兜底：避免 item.abbreviation/nameZh 为 null/undefined 时报错
          const abbreviation = (item.abbreviation || '').toLowerCase();
          const nameZh = (item.nameZh || '').toLowerCase();
          const nameEn = (item.nameEn || '').toLowerCase();
          // 满足任意一个字段匹配即可
          return abbreviation.includes(searchText) || nameZh.includes(searchText) || nameEn.includes(searchText);
        });
      }
    },
    // 获取年级文字（移动端卡片用）
    getGradeText(gradeId) {
      const gradeMap = {
        1: '小一',
        2: '小二',
        3: '小三',
        4: '小四',
        5: '小五',
        6: '小六'
      };
      return gradeMap[gradeId] || '未填寫';
    },
    // 获取模式文字（移动端卡片用）
    getModeText(objectType) {
      const modeMap = {
        0: '圖書館/冒險',
        1: '小測',
        2: '評估',
        3: '作業'
      };
      return modeMap[objectType] || '未知模式';
    },
    // 下载报表
    onDownload() {
      this.getStudentReport();
    },
    // 跳转到答题记录详情
    navigateToResult(row) {
      const baseUrl = '/#/answer-record-detail';
      const queryParams = {
        type: 'library',
        objectName: row.objectName,
        topicId: row.topicId,
        id: row.objectId,
        gradeId: row.gradeId,
        userNo: row.userNo,
        startTime: row.startTime,
        answerResultId: row.id,
        questionListIds: row.questionListIds,
        answerValues: row.answerValues
      };
      const queryString = Object.entries(queryParams)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');
      const fullUrl = `${baseUrl}?${queryString}`;
      window.open(fullUrl, '_blank');
    },
    // 获取学生报表
    getStudentReport() {
      let form = {
        userNameLike: this.listQuery.userNameLike || null,
        userNoLike: this.listQuery.userNoLike || null,
        objectType: this.listQuery.objectType || null,
        parentEmailLike: this.listQuery.parentEmailLike || null,
        gender: this.listQuery.gender,
        branchSchoolId: this.listQuery.branchSchoolId || null,
        gradeId: this.listQuery.gradeId || null,
        studentCodeLike: this.listQuery.studentCodeLike || null,
        createdAtStart: this.convertToDateTimeStr(this.listQuery.createdAt?.[0], 0), // 开始日期（Date 对象）
        createdAtEnd: this.convertToDateTimeStr(this.listQuery.createdAt?.[1], 1),   // 结束日期（Date 对象）
      };
      getStudentReport(form).then((res) => {
        downloadFile(res.data, 'studentReport.xlsx');
      }).catch(err => {
        console.error('下載報表失敗：', err);
        this.$message.error('下載報表失敗，請稍後重試');
      });
    },
    // 时间格式化
    myFormatter(row, column, cellValue) {
      return cellValue ? formatDateTime(new Date(cellValue), 'dd/MM/yyyy HH:mm') : '未填寫';
    },
    // 排序处理
    handleSortChange(column) {
      this.listQuery.orderBy = column.order ? `${column.prop} ${column.order === "descending" ? "desc" : "asc"}` : null;
      this.listQuery._page = 1;
      this.getAnswerResults();
    },
    // 搜索
    onSearch() {
      this.listQuery._page = 1;
      this.getAnswerResults();
      this.countAdminAnswerResults();
    },
    // 重置
    onReset() {
      Object.keys(this.listQuery).forEach((key) => {
        this.listQuery[key] = null;
        if (key === "_page") {
          this.listQuery[key] = 1;
        } else if (key === "_limit") {
          this.listQuery[key] = 10;
        }
      });
      this.getAnswerResults();
      this.countAdminAnswerResults();
    },
    // 编辑按钮（保留原有方法，防止报错）
    onEditorButton(id) {
      let path = `/student/${id}/edit`;
      this.resolveRouter(path);
    },
    // 新增按钮（保留原有方法，防止报错）
    onAdd() {
      let path = `/student/add`;
      this.resolveRouter(path);
    },
    // 详情按钮（保留原有方法，防止报错）
    onDetailButton(id) {
      let path = `/student/${id}`;
      this.resolveRouter(path);
    },
    // 路由跳转（补充缺失方法）
    resolveRouter(path) {
      this.$router.push(path);
    },
    convertToDateTimeStr(isoStr, type) {
      if (!isoStr) {
        return null;
      }
      // 转换函数：ISO字符串 → yyyy-MM-dd HH:mm:ss（本地时区）
      const date = new Date(isoStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      // 提取本地时区的时、分、秒（补0）
      if (type === 0) {
        return `${year}-${month}-${day} 00:00:00`;
      } else {
        return `${year}-${month}-${day} 23:59:59`;
      }
    },
    // 获取答题记录列表
    getAnswerResults() {
      this.tableLoading = true;
      let listQuery = {
        type: 2,
        userNoLike: this.listQuery.userNoLike,
        userNameLike: this.listQuery.userNameLike,
        objectType: this.listQuery.objectType,
        parentEmailLike: this.listQuery.parentEmailLike,
        studentCodeLike: this.listQuery.studentCodeLike,
        branchSchoolId: this.listQuery.branchSchoolId,
        gender: this.listQuery.gender,
        gradeId: this.listQuery.gradeId,
        orderBy: this.listQuery.orderBy,
        _page: this.listQuery._page - 1,
        _limit: this.listQuery._limit,
        createdAtStart: this.convertToDateTimeStr(this.listQuery.createdAt?.[0], 0), // 开始日期（Date 对象）
        createdAtEnd: this.convertToDateTimeStr(this.listQuery.createdAt?.[1], 1),   // 结束日期（Date 对象）
      };
      // 清空空值参数
      Object.keys(listQuery).forEach(key => {
        if (listQuery[key] === null || listQuery[key] === undefined) {
          delete listQuery[key];
        }
      });
      getAnswerResults(listQuery).then((v) => {
        this.tableData = v.data || [];
        this.total = Number(v.headers["x-total-count"]) || 0;
        this.tableLoading = false;
      }).catch(err => {
        console.error('獲取答題記錄失敗：', err);
        this.tableLoading = false;
      });
    },
    countAdminAnswerResults() {
      this.tableLoading = true;
      let listQuery = {
        type: 2,
        userNoLike: this.listQuery.userNoLike,
        userNameLike: this.listQuery.userNameLike,
        objectType: this.listQuery.objectType,
        parentEmailLike: this.listQuery.parentEmailLike,
        studentCodeLike: this.listQuery.studentCodeLike,
        branchSchoolId: this.listQuery.branchSchoolId,
        gender: this.listQuery.gender,
        gradeId: this.listQuery.gradeId,
        orderBy: this.listQuery.orderBy,
        _page: this.listQuery._page - 1,
        _limit: this.listQuery._limit,
        createdAtStart: this.convertToDateTimeStr(this.listQuery.createdAt?.[0], 0), // 开始日期（Date 对象）
        createdAtEnd: this.convertToDateTimeStr(this.listQuery.createdAt?.[1], 1),   // 结束日期（Date 对象）
      };
      // 清空空值参数
      Object.keys(listQuery).forEach(key => {
        if (listQuery[key] === null || listQuery[key] === undefined) {
          delete listQuery[key];
        }
      });
      countAdminAnswerResults(listQuery).then((v) => {
        this.usertotal = v.data || 0;
      }).catch(err => {
        console.error('獲取答題記錄失敗：', err);
        this.tableLoading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 20px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
  }

  .header-right {
    .el-button {
      padding: 8px 16px;
    }
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  //padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  //margin-bottom: 16px;
}

/* 统一风格搜索卡片 */
.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    .el-input, .el-select {
      flex: 1;
      min-width: 180px;
    }

    .search-buttons {
      display: flex;
      gap: 8px;
    }
  }
}

/* 表格/卡片容器 */
.table-container {
  width: 100%;

  /* PC端表格样式 */
  .pc-table {
    ::v-deep .el-table {
      --el-table-header-text-color: #4e5969;
      --el-table-row-hover-bg-color: #f8f9fa;
    }

    ::v-deep .el-table th {
      background: #f8f9fa;
      font-weight: 600;
    }

    ::v-deep .cell {
      color: #1f2937;
    }
  }

  /* 手机端卡片列表样式 */
  .mobile-cards {
    display: none;
    gap: 12px;
    flex-direction: column;

    .user-card {
      background: #fff;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      padding: 16px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;

        .user-name {
          font-size: 16px;
          font-weight: 600;
          color: #1f2937;
        }
      }

      .card-body {
        margin-bottom: 16px;

        .info-item {
          display: flex;
          margin-bottom: 8px;
          line-height: 1.5;

          .info-label {
            color: #6c757d;
            width: 80px;
            flex-shrink: 0;
          }

          .info-value {
            color: #1f2937;
            flex: 1;
            word-break: break-all;
          }
        }
      }

      .card-footer {
        display: flex;
        gap: 8px;
        justify-content: flex-end;
      }
    }

    .empty-tip {
      text-align: center;
      padding: 32px;
      color: #999;
      font-size: 14px;
    }
  }
}

/* 分页样式 */
.pagination-wrap {
  text-align: center;
  ::v-deep .el-pagination {
    --el-pagination-button-bg-color: #fff;
    --el-pagination-button-hover-bg-color: #f8f9fa;
    --el-pagination-button-active-bg-color: #409eff;
  }
}

/* 响应式适配（和统一风格一致） */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    padding: 12px 16px;
    flex-direction: column;
    align-items: flex-start;
  }

  .layout {
    padding: 12px;
  }

  .search-card .search-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  /* 隐藏PC表格，显示手机卡片 */
  .table-container .pc-table {
    display: none;
  }
  .table-container .mobile-cards {
    display: flex;
  }
}
</style>